export function IconBellSnooze() {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7501 6.75C15.7501 13.75 18.7501 15.75 18.7501 15.75H0.750058C0.750058 15.75 3.75006 13.75 3.75006 6.75C3.75006 5.1587 4.3822 3.63258 5.50742 2.50736C6.63264 1.38214 8.15876 0.75 9.75006 0.75C10.3172 0.75 10.8761 0.8303 11.4115 0.984605"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        transform="translate(2.25 1.25)"
        vectorEffect="non-scaling-size"
      />
      <path
        d="M4.21012 0.750124C4.03431 1.0532 3.78197 1.30478 3.47835 1.47965C3.17473 1.65453 2.8305 1.74658 2.48012 1.74658C2.12974 1.74658 1.78551 1.65453 1.4819 1.47965C1.17828 1.30478 0.925934 1.0532 0.750124 0.750124"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        transform="translate(9.52 20.25)"
        vectorEffect="non-scaling-size"
      />
      <path
        d="M0.750012 0.75H4.25001L0.750012 4.75H4.25001"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        transform="translate(10.25 5.75)"
        vectorEffect="non-scaling-size"
      />
      <path
        d="M0.750009 0.75H3.25001L0.750009 3.75H3.25001"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        transform="translate(16.25 0.25)"
        vectorEffect="non-scaling-size"
      />
    </svg>
  );
}
